"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTopEventCursorSSE = exports.selectEventProbabilitiesCursorSSEById = exports.selectEventProbabilitiesStatusSSEById = exports.selectEventProbabilitiesChannelSSEById = exports.selectEventProbabilitiesCursorsSSE = exports.selectEventProbabilitiesStatusesSSE = exports.selectEventProbabilitiesChannelsSSE = exports.selectTopEventsSSEConfiguration = exports.selectEventProbabilitiesSSEConfiguration = exports.selectTopEventChannelStatusError = exports.selectTopEventChannelStatusType = exports.selectTopEventChannelSSE = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const selectors_1 = require("../../ConfigProvider/selectors");
const slice_1 = require("../slice");
const selectTopEventChannelSSE = (state) => { var _a; return (_a = state.eventsProvider.sse.topEvent.channel) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.topEvent.channel; };
exports.selectTopEventChannelSSE = selectTopEventChannelSSE;
const selectTopEventChannelStatusType = (state) => {
    var _a;
    return (_a = state.eventsProvider.sse.topEvent.status.type) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.topEvent.status.type;
};
exports.selectTopEventChannelStatusType = selectTopEventChannelStatusType;
const selectTopEventChannelStatusError = (state) => {
    var _a;
    return (_a = state.eventsProvider.sse.topEvent.status.error) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.topEvent.status.error;
};
exports.selectTopEventChannelStatusError = selectTopEventChannelStatusError;
const selectEventProbabilitiesSSEConfiguration = (state, { eventId, cursor, reloadIdsToSkip }) => {
    const reloadIds = (reloadIdsToSkip === null || reloadIdsToSkip === void 0 ? void 0 : reloadIdsToSkip.length)
        ? `&reload-ids-to-skip=${reloadIdsToSkip}`
        : '';
    return `${(0, selectors_1.selectApiBasePath)(state)}/events/${eventId}/probabilities/updates?cursor=${cursor}&cursor-reset-policy=${betweb_openapi_axios_1.CursorResetPolicy.Strict}${reloadIds}`;
};
exports.selectEventProbabilitiesSSEConfiguration = selectEventProbabilitiesSSEConfiguration;
const selectTopEventsSSEConfiguration = (state, { locale, cursor, reloadIdsToSkip }) => {
    const reloadIds = (reloadIdsToSkip === null || reloadIdsToSkip === void 0 ? void 0 : reloadIdsToSkip.length)
        ? `&reload-ids-to-skip=${reloadIdsToSkip}`
        : '';
    return `${(0, selectors_1.selectApiBasePath)(state)}/events/updates?locale=${locale}&cursor=${cursor}&top=true&cursor-reset-policy=${betweb_openapi_axios_1.CursorResetPolicy.Strict}${reloadIds}`;
};
exports.selectTopEventsSSEConfiguration = selectTopEventsSSEConfiguration;
const selectEventProbabilitiesChannelsSSE = (state) => {
    var _a;
    return (_a = state.eventsProvider.sse.eventsProbabilities.channels) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.eventsProbabilities.channels;
};
exports.selectEventProbabilitiesChannelsSSE = selectEventProbabilitiesChannelsSSE;
const selectEventProbabilitiesStatusesSSE = (state) => {
    var _a;
    return (_a = state.eventsProvider.sse.eventsProbabilities.statuses) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.eventsProbabilities.statuses;
};
exports.selectEventProbabilitiesStatusesSSE = selectEventProbabilitiesStatusesSSE;
const selectEventProbabilitiesCursorsSSE = (state) => {
    var _a;
    return (_a = state.eventsProvider.sse.eventsProbabilities.cursors) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.eventsProbabilities.cursors;
};
exports.selectEventProbabilitiesCursorsSSE = selectEventProbabilitiesCursorsSSE;
const selectEventProbabilitiesChannelSSEById = (state, eventId) => {
    var _a;
    return (_a = state.eventsProvider.sse.eventsProbabilities.channels[eventId]) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.eventsProbabilities.channels[eventId];
};
exports.selectEventProbabilitiesChannelSSEById = selectEventProbabilitiesChannelSSEById;
const selectEventProbabilitiesStatusSSEById = (state, eventId) => {
    var _a;
    return (_a = state.eventsProvider.sse.eventsProbabilities.statuses[eventId]) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.eventsProbabilities.statuses[eventId];
};
exports.selectEventProbabilitiesStatusSSEById = selectEventProbabilitiesStatusSSEById;
const selectEventProbabilitiesCursorSSEById = (state, eventId) => {
    var _a;
    return (_a = state.eventsProvider.sse.eventsProbabilities.cursors[eventId]) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.eventsProbabilities.cursors[eventId];
};
exports.selectEventProbabilitiesCursorSSEById = selectEventProbabilitiesCursorSSEById;
const selectTopEventCursorSSE = (state) => { var _a; return (_a = state.eventsProvider.sse.topEvent.cursor) !== null && _a !== void 0 ? _a : slice_1.initialState.sse.topEvent.cursor; };
exports.selectTopEventCursorSSE = selectTopEventCursorSSE;
//# sourceMappingURL=sseSelectors.js.map